<template>
    <div>
        <h4 class="text-primary">Parametres des véhicules</h4>
        <hr>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link" id="nav-profile-tab" data-toggle="tab" data-target="#nav-profile" type="button"
                    role="tab" aria-controls="nav-profile" aria-selected="false">Articles</button>
                <button class="nav-link" id="nav-contact-tab" data-toggle="tab" data-target="#nav-contact" type="button"
                    role="tab" aria-controls="nav-contact" aria-selected="false">Types de
                    vehicules</button>
                <button class="nav-link active" id="nav-home-tab" data-toggle="tab" data-target="#nav-article"
                    type="button" role="tab" aria-controls="nav-article" aria-selected="true">Types
                    Articles</button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <IndexArticle></IndexArticle>
            </div>
            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                <IndexTypesVehicule></IndexTypesVehicule>
            </div>
            <div class="tab-pane fade show active" id="nav-article" role="tabpanel" aria-labelledby="nav-home-tab">
                <IndexTypesArticle></IndexTypesArticle>
            </div>
        </div>
    </div>
</template>

<script>
import IndexArticle from "./articles/IndexArticle.vue";
import IndexTypesVehicule from "./types_vehicules/IndexType.vue";
import IndexTypesArticle from "./types_articles/IndexTypesArticle.vue";

export default {
    components: { IndexArticle, IndexTypesVehicule, IndexTypesArticle }
}
</script>